import gql from 'graphql-tag';

export const RuleSetFragment = gql`
  fragment AllowRedemptionWithoutLogin on AllowRedemptionWithoutLogin {
    ruleSetType: _type
  }

  fragment BetweenDates on BetweenDates {
    ruleSetType: _type
    endDate
    startDate
  }

  fragment BetweenTimes on BetweenTimes {
    ruleSetType: _type
    endTime
    startTime
  }

  fragment CartProperty on CartProperty {
    ruleSetType: _type
    key
    negated
    operator
    value
  }

  fragment CoolDown on CoolDown {
    ruleSetType: _type
    minimumElapsedTimeSeconds
  }

  fragment DayOfWeekBand on DayOfWeekBand {
    ruleSetType: _type
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
    sunday
  }

  fragment FirstOrderOnly on FirstOrderOnly {
    ruleSetType: _type
  }

  fragment Limit on Limit {
    ruleSetType: _type
    interval
    maximumRedemptions
  }

  fragment Purchase on Purchase {
    ruleSetType: _type
    quantity
    sanityId
  }

  fragment RequiresAssignment on RequiresAssignment {
    ruleSetType: _type
  }
`;

export default RuleSetFragment;
